(function () {
  'use strict';

  // Straps are separate products per color, not variants of one product,
  // so the native bundle block can't offer a Black/Beige picker on its own.
  var STRAP_CONFIG = {
    wrist: {
      Black: 'black-wrist-phone-case-strap',
      Beige: 'beige-wrist-phone-case-strap'
    },
    crossbody: {
      Black: 'black-crossbody-phone-case-strap',
      Beige: 'beige-crossbody-phone-case-strap'
    }
  };

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js').then(function (r) {
      if (!r.ok) throw new Error('Failed to fetch ' + handle);
      return r.json();
    });
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  // --- Part 1: make bundle checkboxes actually add to cart under EliteCart ---
  // EliteCart intercepts the Add to Cart button's click directly (and likely
  // calls preventDefault before the form ever actually submits), so listening
  // for the form's 'submit' event never fires. Listening on 'click' in the
  // capture phase instead guarantees this runs regardless of what EliteCart
  // does with the event afterward.
  function wireBundleAddToCartFix() {
    if (document.body.dataset.bundleClickWired) return;
    document.body.dataset.bundleClickWired = 'true';

    document.addEventListener('click', function (e) {
      var button = e.target.closest('button[type="submit"], button[name="add"]');
      if (!button) return;

      var form = button.closest('form');
      if (!form) return;
      var formId = form.getAttribute('id');
      if (!formId) return;

      var bundleCheckboxes = document.querySelectorAll(
        'details[form="' + formId + '"] input[name="bundles"]'
      );
      if (bundleCheckboxes.length === 0) return;

      var checked = Array.prototype.filter.call(bundleCheckboxes, function (cb) {
        return cb.checked;
      });
      if (checked.length === 0) return;

      var items = checked.map(function (cb) {
        return { id: parseInt(cb.value, 10), quantity: 1 };
      });

      // Slight delay so the main product's own add-to-cart (handled by
      // EliteCart) goes out first; this is a supplementary request.
      setTimeout(function () {
        addToCart(items).catch(function (err) {
          console.error('Bundle add-to-cart fix failed:', err);
        });
      }, 400);
    }, true);
  }

  // --- Part 2: group Wrist/Crossbody strap rows with their own color picker ---
  function enhanceStrapRows() {
    document.querySelectorAll('.product-bundle__info').forEach(function (row) {
      if (row.dataset.strapEnhanced) return;

      var titleEl = row.querySelector('.horizontal-product__title');
      var checkbox = row.querySelector('input[name="bundles"]');
      if (!titleEl || !checkbox) return;

      var titleText = titleEl.textContent.toLowerCase();
      var strapType = null;
      if (titleText.indexOf('wrist') !== -1) strapType = 'wrist';
      else if (titleText.indexOf('crossbody') !== -1) strapType = 'crossbody';
      if (!strapType) return;

      row.dataset.strapEnhanced = 'true';

      var colorHandles = STRAP_CONFIG[strapType];
      var currentColor = titleText.indexOf('black') !== -1 ? 'Black' : 'Beige';

      var wrapper = document.createElement('div');
      wrapper.className = 'strap-color-wrapper';
      wrapper.style.position = 'relative';
      wrapper.style.display = 'inline-block';
      wrapper.style.marginTop = '4px';

      var select = document.createElement('select');
      select.className = 'select strap-color-select';
      select.style.paddingRight = '28px';
      select.style.appearance = 'none';
      select.style.webkitAppearance = 'none';
      Object.keys(colorHandles).forEach(function (colorName) {
        var opt = document.createElement('option');
        opt.value = colorName;
        opt.textContent = colorName;
        if (colorName === currentColor) opt.selected = true;
        select.appendChild(opt);
      });

      var arrow = document.createElement('span');
      arrow.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">' +
          '<path d="M1 3L5 7L9 3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';
      arrow.style.position = 'absolute';
      arrow.style.right = '10px';
      arrow.style.top = '50%';
      arrow.style.transform = 'translateY(-50%)';
      arrow.style.pointerEvents = 'none';

      wrapper.appendChild(select);
      wrapper.appendChild(arrow);

      var mediaImg = row.querySelector('.horizontal-product__media img');

      select.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });

      select.addEventListener('change', function () {
        var handle = colorHandles[select.value];
        fetchProduct(handle).then(function (product) {
          var variant = product.variants[0];
          checkbox.value = variant.id;
          checkbox.setAttribute('data-price', variant.price);
          titleEl.textContent = product.title;
          if (mediaImg && product.featured_image) {
            mediaImg.src = product.featured_image;
            mediaImg.srcset = '';
          }
        }).catch(function (err) {
          console.error('Strap color swap failed:', err);
        });
      });

      titleEl.parentNode.insertBefore(wrapper, titleEl.nextSibling);
    });
  }

  // --- Part 3: auto-match the screen protector to the current device and show its model ---
  function cleanDeviceLabel(deviceString) {
    return (deviceString || '')
      .replace(/case\s*$/i, '')
      .replace(/^iphone\s*/i, '')
      .replace(/^samsung galaxy\s*/i, '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function guessMatchingVariant(variants, deviceString) {
    var cleaned = cleanDeviceLabel(deviceString);
    if (!cleaned) return variants[0];

    var candidates = variants.map(function (v) {
      return { variant: v, title: cleanDeviceLabel(v.public_title || v.title || '') };
    });

    var exact = candidates.find(function (c) { return c.title === cleaned; });
    if (exact) return exact.variant;

    var closest = candidates
      .filter(function (c) { return c.title.indexOf(cleaned) !== -1; })
      .sort(function (a, b) {
        return Math.abs(a.title.length - cleaned.length) - Math.abs(b.title.length - cleaned.length);
      })[0];

    return closest ? closest.variant : variants[0];
  }

  function enhanceScreenProtectorRow() {
    var bundleContainer = document.querySelector('[id^="ProductBundle-"]');
    if (!bundleContainer) return;
    var currentDevice = bundleContainer.dataset.currentDevice;

    document.querySelectorAll('.product-bundle__info').forEach(function (row) {
      if (row.dataset.spEnhanced) return;

      var titleEl = row.querySelector('.horizontal-product__title');
      var checkbox = row.querySelector('input[name="bundles"]');
      var handle = row.dataset.productHandle;
      if (!titleEl || !checkbox || !handle) return;

      var titleText = titleEl.textContent.toLowerCase();
      if (titleText.indexOf('screen protector') === -1) return;

      row.dataset.spEnhanced = 'true';

      var modelLabel = document.createElement('p');
      modelLabel.className = 'text-xs text-opacity leading-tight';
      modelLabel.textContent = 'Matching your device\u2026';
      titleEl.parentNode.insertBefore(modelLabel, titleEl.nextSibling);

      fetchProduct(handle).then(function (product) {
        var available = product.variants.filter(function (v) { return v.available; });
        var pool = available.length > 0 ? available : product.variants;
        var match = guessMatchingVariant(pool, currentDevice);

        modelLabel.textContent = match.public_title || match.title;
        checkbox.value = match.id;
        checkbox.setAttribute('data-price', match.price);
      }).catch(function (err) {
        console.error('Screen protector match failed:', err);
        modelLabel.remove();
      });
    });
  }

  function initAll() {
    wireBundleAddToCartFix();
    enhanceStrapRows();
    enhanceScreenProtectorRow();
  }

  document.addEventListener('DOMContentLoaded', initAll);

  var observer = new MutationObserver(function () {
    initAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();